export function lostReasons(){
    let lostReasons = [
        {id: 1, label:'Lost By SR'},
        {id: 2, label:'Lost By Staff'},
        {id: 3, label:'Lost By Delivery Agent'},
        {id: 4, label:'Dispute Client Consignee'},
        {id: 5, label:'Lost by coloader'},
        {id: 6, label:'Lost by local transport'},
    ]
    return lostReasons;
}

export function lostSubReasons(reason){
    let subReasons = []
    switch(reason){
        case 1:
            subReasons = [
                { "ReasonId": 8, "Reason": "Lost On Field" },
                { "ReasonId": 9, "Reason": "Manipulatation/Tampering by SR" },
                { "ReasonId": 10, "Reason": "Wrong Delivery" },
                { "ReasonId": 11, "Reason": "Theft By SR" },
                { "ReasonId": 12, "Reason": "Manual Delivery" },
              ]
            break;
        
        case 2:
            subReasons = [ 
                { "ReasonId": 13, "Reason": "Bagging/Debagging Process Failure" }, 
                { "ReasonId": 14, "Reason": "Manipulatation/Tampering by Staff" }, 
                { "ReasonId": 15, "Reason": "Process Neglience" }, 
                { "ReasonId": 16, "Reason": "Theft By SR" }, 
                { "ReasonId": 17, "Reason": "Untraceble In Branch" }, 
            ];
            break;
        
        case 3:
            subReasons = [
                { "ReasonId": 18, "Reason": "Lost By Agent/SR/Staff" },
                { "ReasonId": 19, "Reason": "Manipulatation/Tampering by Staff" },
                { "ReasonId": 20, "Reason": "Manual Delivery" },
                { "ReasonId": 21, "Reason": "Theft By SR/Staff" },
                { "ReasonId": 22, "Reason": "Wrong Delivery" },
              ];
            break;
        
        case 4:
            subReasons = [
                { "ReasonId": 23, "Reason": "Damaged In Intransit" },
                { "ReasonId": 24, "Reason": "Intact Shipment Rejected By Client" },
                { "ReasonId": 25, "Reason": "Product Mismatch" },
                { "ReasonId": 26, "Reason": "Product Missing" },
                { "ReasonId": 27, "Reason": "Product Quality Issue" },
                { "ReasonId": 28, "Reason": "Shipment Weight Dispute" },
                { "ReasonId": 29, "Reason": "Snatched By Consignee" },
                { "ReasonId": 30, "Reason": "Product Quantity Issue" },
              ];
            break;

        case 5:
            subReasons = [
                { "ReasonId": 31, "Reason": "Damaged In Intransit" },
                { "ReasonId": 32, "Reason": "Lost Intansit" },
                { "ReasonId": 33, "Reason": "Manipulatation/Tampering by Coloader Staff" },
                { "ReasonId": 34, "Reason": "Theft By Coloader Staff" },
                { "ReasonId": 35, "Reason": "Vehicle Accident" },
              ];
            break;

        case 6:
            subReasons = [
                { "ReasonId": 36, "Reason": "Damaged In Intransit" },
                { "ReasonId": 37, "Reason": "Lost Intansit" },
                { "ReasonId": 38, "Reason": "Manipulatation/Tampering by Coloader Staff" },
                { "ReasonId": 39, "Reason": "Theft By Coloader Staff" },
                { "ReasonId": 40, "Reason": "Vehicle Accident" },
              ];
            break;
        default:
            subReasons = [];
    }

    return subReasons;
}


// WEBPACK FOOTER //
// ./src/services/lostReasons.js